export default "__VITE_ASSET__BF4UzLf5__"